import { CtaButton } from "../../Buttons";
import RaceweekFlag from "../../Cloudinary/RaceweekFlag";

const RaceweekHeader = ({ countryName, gamedayId, onBack }) => {
  return (
    <div className="si-headToHead-raceweek-country-header">
      <div className="si-headToHead-raceweek-country-header-side">
        <CtaButton
          onlyIcon={true}
          icon="f1i-ar-left"
          variant="ghost"
          size="md"
          onClick={onBack}
        />
      </div>
      <div className="si-headToHead-raceweek-country-header-center">
        <div className="si-headToHead-raceweek-country-header-center-title">
          <RaceweekFlag size="lg" countryName={countryName} />
          <h3 className="si-headToHead-raceweek-country-header-center-title-text">
            {countryName}
          </h3>
        </div>
        <div className="si-headToHead-raceweek-country-header-center-round">
          <span className="si-headToHead-raceweek-country-header-center-round-text">
            Round {gamedayId}
          </span>
        </div>
      </div>
      <div className="si-headToHead-raceweek-country-header-side"></div>
    </div>
  );
};

export default RaceweekHeader;
